import {
  TrendingUp,
  Globe,
  Settings2,
  ClipboardCheck,
  MessageSquareHeart,
  Crown,
  GraduationCap,
  ArrowUpRight,
} from "lucide-react";

const SERVICES = [
  {
    id: "revenue",
    icon: TrendingUp,
    label: "01 · Revenue",
    title: "Revenue Management",
    desc: "Dynamic pricing, yield management and occupancy strategy that turns vacancies into profit.",
    span: "lg:col-span-6",
  },
  {
    id: "ota",
    icon: Globe,
    label: "02 · Distribution",
    title: "OTA Optimisation",
    desc: "Strategies that drive visibility and bookings through third-party booking sites.",
    span: "lg:col-span-6",
  },
  {
    id: "ops",
    icon: Settings2,
    label: "03 · Operations",
    title: "Operational Systems",
    desc: "SOPs, housekeeping reports, staffing structures and maintenance systems built for scale.",
    span: "lg:col-span-4",
  },
  {
    id: "audit",
    icon: ClipboardCheck,
    label: "04 · Audit",
    title: "Profit Audits",
    desc: "Comprehensive review of pricing, processes, competitors and expenses, with a 90-day action plan.",
    span: "lg:col-span-4",
  },
  {
    id: "guest",
    icon: MessageSquareHeart,
    label: "05 · Guest",
    title: "Guest Systems",
    desc: "Communication automation, review management and direct-booking strategies that build loyalty.",
    span: "lg:col-span-4",
  },
  {
    id: "retainer",
    icon: Crown,
    label: "06 · Retainer",
    title: "Management Retainers",
    desc: "Ongoing, continuous support across revenue management and operations for sustainable growth.",
    span: "lg:col-span-6",
  },
  {
    id: "training",
    icon: GraduationCap,
    label: "07 · People",
    title: "Staff Training",
    desc: "Ongoing training programmes and SOP implementation that deliver exceptional guest experiences consistently.",
    span: "lg:col-span-6",
  },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 md:py-36 bg-[#070809]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-20">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <span className="block w-10 h-px bg-[#C2A878]" />
              <span className="text-xs tracking-[0.3em] uppercase text-[#C2A878] font-semibold">
                What we do
              </span>
            </div>
            <h2
              data-testid="services-heading"
              className="font-serif font-light text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-white tracking-tight"
            >
              Seven disciplines.
              <br />
              <em className="text-[#C2A878] not-italic">One</em> outcome: profit.
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 self-end">
            <p className="text-white/65 text-base md:text-lg leading-relaxed">
              Whether you own a single Mount Maunganui apartment or a 28-room
              motel, the levers that move accommodation profitability are the
              same. We work across seven disciplines — engaged individually, or
              orchestrated together inside a retainer.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          {SERVICES.map((s) => {
            const Icon = s.icon;
            return (
              <article
                key={s.id}
                data-testid={`service-card-${s.id}`}
                className={`group relative col-span-1 ${s.span} bg-white/[0.025] border border-white/10 p-8 md:p-10 hover:bg-white/[0.04] hover:border-[#C2A878]/40 hover:-translate-y-1 transition-all duration-500`}
              >
                <div className="flex items-start justify-between mb-8">
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 border border-white/15 flex items-center justify-center group-hover:border-[#C2A878] transition-colors">
                      <Icon className="w-5 h-5 text-[#C2A878]" />
                    </div>
                    <span className="text-[10px] tracking-[0.3em] uppercase text-white/50 font-semibold">
                      {s.label}
                    </span>
                  </div>
                  <ArrowUpRight className="w-5 h-5 text-white/40 group-hover:text-[#C2A878] group-hover:rotate-12 transition-all" />
                </div>

                <h3 className="font-serif text-2xl md:text-3xl text-white mb-4 leading-tight">
                  {s.title}
                </h3>
                <p className="text-white/65 leading-relaxed max-w-xl">
                  {s.desc}
                </p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
